function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.1 7.071l3.89 3.89a.5.5 0 00.707 0l.707-.708a.5.5 0 000-.707L3.515 5.658l3.889-3.89a.5.5 0 000-.707L6.697.354a.5.5 0 00-.707 0L2.1 4.244v-.001L1.04 5.303a.5.5 0 000 .707L2.1 7.071z"
})));